import React from 'react';
import * as mobxReact from 'mobx-react';
import Text from '../../../../../../global/text/text';
import { OpenIcon } from '../../../../../../global/icons/icons';

interface SignInFormHeaderProps {
    openSignInFormPreview: () => void;
}
export const SignInFormHeader = mobxReact.observer(((props: SignInFormHeaderProps) => {
    const {
        openSignInFormPreview,
    } = props;

    return (
        <div className='oe-popup-layout__header website-custom-field' >
            <div className='website-custom-field-header'>
                <div className='website-custom-field-header__item'></div>
                <div className='website-custom-field-header__item'>
                    <div className={'preview'} onClick={() => openSignInFormPreview()}>
                        <OpenIcon/>
                        <Text className={'preview-text'} message='Preview'/>
                    </div>
                </div>
            </div>

        </div>
    );
}));
